import { DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutEdiCommControlLookup } from "./autogen/AutogenLayoutEdiCommControlLookup";

export class EdiCommControlLookup extends AutogenLayoutEdiCommControlLookup {
    private static readonly OUTBOUND = "O";

    onLoad() {
        this.sourceEdiCommControlLookup.addBeforeExecutionListener((event: DataSourceExecutionEvent) => {
            if (event.filter?.direction_input === EdiCommControlLookup.OUTBOUND) {
                this.table1.removeColumn("columnHeaderStatus");
            }
        });
    }
}